import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IntegrationService } from '../../../../services/integration.service';
import { ActivatedRoute } from '@angular/router';
import { FNFResponse } from '../../../../models/response';

@Component({
  selector: 'app-integration-redirection',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './integration-redirection.component.html',
  styleUrl: './integration-redirection.component.css',
})
export class IntegrationRedirectionComponent {
  progressStatus = 'In Progress';
  integrationService = inject(IntegrationService);
  route = inject(ActivatedRoute);

  displayWarning = true;
  displaySuccess = false;
  displayError = false;

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;
    const queryString = new URLSearchParams(queryParams).toString();
    this.integrationService.cloverConnectionCallback(queryString).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.displayWarning = false;
          this.displaySuccess = false;
          this.displayError = true;
          return;
        } else if (!response.data) {
          this.displayWarning = false;
          this.displaySuccess = false;
          this.displayError = true;
          return;
        }
        this.displayWarning = false;
        this.displaySuccess = true;
        this.displayError = false;
      },
      error: () => {
        this.displayWarning = false;
        this.displaySuccess = false;
        this.displayError = true;
      },
    });
  }

  closeTab(): void {
    window.close();
  }
}
